import React from 'react'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Carcasse from '../../../Carcasse'

import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents'

import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      tables: [],
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getCarcasse()
    }
  }

  getCarcasse = async () => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'carcasse',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle,
        libelle: result.results.libelle,
        produit_id: result.results.produit_id,
        tables: result.results.tables,
        height: result.results.height,
        width: result.results.width,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (data, name) => {
    this.setState({
      [name]: data
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      produit_id: undefined,
      height: undefined,
      tables: undefined,
      width: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'carcasse',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      produit_id: this.state.produit_id,
      tables: this.state.tables.map(table => ({
        couverts_max: table.couverts_max,
        couverts_min: table.couverts_min,
        x: table.x,
        y: table.y,
        verticale: table.verticale,
        groupe_id: table.groupe_id,
        table_id: table.id,
      })),
      height: this.state.height,
      width: this.state.width,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'restaurant', {
      requete: 'carcasse',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
        justify="center"
        alignItems="stretch">
        <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction={'row'}>
          <Grid item xs={3} style={{ margin: 0, padding: 0, paddingRight: 1, paddingLeft: 1 }}>
            <Input
              title={EurestoI18n.t('commun:Nom')}
              autoFocus={autoFocus}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'libelle'}
              value={this.state.libelle !== undefined ? this.state.libelle : ''}
              type={'text'}
            />
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 0, paddingRight: 1, paddingLeft: 1 }}>
            <DataComponent
              title={EurestoI18n.t('crm:Restaurant')}
              name="produit_id"
              disabled={disabled}
              type={Constants.typeSaisie.ComboSimple}
              onChange={this.onChangeState}
              data={this.state.produit_id}
              object={Constants.donnee.produit}
              module={Constants.module.RESTAURANT}
            />
          </Grid>
          <Grid item style={{ margin: 0, padding: 0, paddingRight: 1, paddingLeft: 1 }}>
            <Input
              title={EurestoI18n.t('commun:Hauteur')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'height'}
              value={this.state.height}
              type={'text'}
            />
          </Grid>
          <Grid item style={{ margin: 0, padding: 0, paddingRight: 1, paddingLeft: 1 }}>
            <Input
              title={EurestoI18n.t('commun:Largeur')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'width'}
              value={this.state.width}
              type={'text'}
            />
          </Grid>
        </Grid>
        <Carcasse tables={this.state.tables} height={this.state.height} width={this.state.width} onChange={this.onChangeState} disabled={disabled} name={'tables'} />
      </Grid>
    )
  }

  render() {
    return (
      <EurestoForm key={this.state.key}
        {...this.props.formProps}
        libelle={this.state.defaultLibelle}
        action={this.state.action}
        isAllow={this.props.isAllow}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onDelete={this.onDelete}
        onArchive={this.onArchive}
        onView={this.onView}
        libelleAdd={EurestoI18n.t('commun:Nouvelle carcasse')}
        children={this.form} />
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/Carcasse.js